// Smart Sash Admin Panel - Device Management Page

import { Alert, Button, PermissionGate } from '@/components/common';
import { DeviceDeleteModal, DeviceFormModal, DeviceTable } from '@/components/device';
import { useDeviceManagement } from '@/hooks/useDeviceManagement';
import React from 'react';

export const DeviceManagement: React.FC = () => {
  const {
    devices,
    institutions,
    labs,
    pagination,
    isLoading,
    error,
    currentPage,
    pageSize,
    pageSizeOptions,
    showModal,
    modalMode,
    showDeleteModal,
    deviceToDelete,
    formData,
    isSaving,
    setCurrentPage,
    handlePageSizeChange,
    handleCreateClick,
    handleEditClick,
    handleDeleteClick,
    handleSubmit,
    handleDelete,
    handleInputChange,
    handleInstitutionChange,
    closeModal,
    closeDeleteModal,
    clearError,
  } = useDeviceManagement();

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 mb-0">Device Management</h1>
              <p className="text-muted">Manage hardware devices and equipment</p>
            </div>
            <PermissionGate action="device:create">
              <Button variant="primary" icon="fas fa-plus" onClick={handleCreateClick}>
                Add Device
              </Button>
            </PermissionGate>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="row mb-3">
          <div className="col-12">
            <Alert variant="danger" dismissible onDismiss={clearError}>
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </Alert>
          </div>
        </div>
      )}

      {/* Devices Table */}
      <div className="row">
        <div className="col-12">
          <DeviceTable
            devices={devices}
            labs={labs}
            institutions={institutions}
            pagination={pagination}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            isLoading={isLoading}
            onPageChange={setCurrentPage}
            onPageSizeChange={handlePageSizeChange}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
          />
        </div>
      </div>

      {/* Create/Edit Modal */}
      <DeviceFormModal
        isOpen={showModal}
        mode={modalMode}
        formData={formData}
        institutions={institutions}
        labs={labs}
        isSaving={isSaving}
        onInputChange={handleInputChange}
        onInstitutionChange={handleInstitutionChange}
        onSubmit={handleSubmit}
        onClose={closeModal}
      />

      {/* Delete Confirmation Modal */}
      <DeviceDeleteModal
        isOpen={showDeleteModal}
        device={deviceToDelete}
        isSaving={isSaving}
        onConfirm={handleDelete}
        onClose={closeDeleteModal}
      />
    </div>
  );
};

export default DeviceManagement;
